import { useState, useEffect } from 'react';

export const Delay = ({ seconds = 5, children }) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), seconds * 1000);

    return () => clearTimeout(timeout);
  });

  return show ? children : undefined;
};
